import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import backend from 'i18next-http-backend';

i18n
  // .use(HttpApi)
  .use(backend)
  .use(initReactI18next)
  .init({
    react: {
      useSuspense: false,
    },
    fallbackLng: 'en',

    nsSeparator: '->>',

    parseMissingKeyHandler: (key) => {
      const temp = key.split('.');
      if (temp.length > 1) {
        temp.shift();
      }
      return temp.join('.');
    },

    interpolation: {
      escapeValue: false,
    },
    ns: [
      'accessArrangement',
      'components',
      'admin',
      'profile',
      'resit',
      'exam',
      'helpdesk',
      'appeal',
      'withdrawal',
      'amendment',
      'entryProof',
      'specialConsideration',
      'usefulInformation',
      'announcementsNotifications',
      'transaction',
      'session',
    ],
    defaultNS: 'components',

    // backend: {
    //   crossDomain: true,
    //   loadPath:
    //     import.meta.env.PROD
    //       ? `${import.meta.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`
    //       : `${import.meta.env.VITE_APP_TRANSLATION_DOMAIN}/{{lng}}/{{ns}}.json`,
    // },
  });

export default i18n;
